import { useEvent } from "shared/lib/useEvent"

import { useFavoritesPrefetch } from "entities/favorites/api/useFavoritesPrefetch"
import { useFavorites } from "entities/projects/api/useFavorites"
import { ProductConfiguratorResult } from "widgets/product-configurator/model/useProductConfiguratorModel"

export function useFavorite(configuration: ProductConfiguratorResult) {
  useFavoritesPrefetch()
  const { toggleFavorite, isFavorite } = useFavorites()
  const handleToggleFavorite = useEvent(() => {
    toggleFavorite(configuration)
  })

  return {
    isFavorite: isFavorite(configuration),
    toggleFavorite: handleToggleFavorite
  }
}
